import React from "react";

import CallPilot from "../CallPilot";
import { CircularProgress } from "@material-ui/core";
import SiteSurvey from "../../../SiteSurvey/SiteSurvey";
import ErrorModal from "../Modals/ErrorModal";

const ProposalMenu = ({
  // Mapped Proposals
  mappedProposals,

  // Proposal and Team Details
  proposal, // { id1, teamPpw }
  team, // { id1, ppw }
  signedProp,
  callComplete,

  // Customer Information
  customer, // { projectID }
  primaryContact,

  // Address Information
  street,
  city,
  state,
  zip,

  // Financing Details
  currentProp, // { financingSource, contractSigned }
  loanA, // { isPpa }

  // Envelope Details
  envelopeId,
  envelopeStatus,

  // Callback Functions
  setSendCiaDoc,
  setViewProposals,
  setEnvelopeStatus,
  setCallComplete,
  buildNewProposal,
  createUpdatedProposal,

  // Miscellaneous
  loading,
  isValidNetPpw,
}) => {
  console.log("Valid Net PPW", isValidNetPpw);
  return (
    <>
      <div className="container">
        <div className="row">
          <h3 className="menuFont">Proposals</h3>
        </div>
        <div className="custContainer menu">
          <div className="row">
            <div className="menuBorder"></div>
          </div>
          <div className="row-lg-10">{mappedProposals}</div>
          <div className="row">
            <div className="col-sm">
              <button
                className={!isValidNetPpw ? "proposalButton disabled" : "proposalButton cancel"}
                onClick={() => {
                  setSendCiaDoc(true);
                  setViewProposals(false);
                }}
              >
                Send CIA
              </button>
              <CallPilot
                variant="checkStatusOnly"
                financeSource={currentProp.financingSource}
                ppa={loanA?.isPpa}
                envelopeId={envelopeId}
                envelopeStatus={envelopeStatus}
                setEnvelopeStatus={setEnvelopeStatus}
                projectID={customer.projectID}
              />
            </div>
            <div className="col">
              <button
                className={!isValidNetPpw ? "proposalButton disabled" : "proposalButton confirm"}
                disabled={loading || !isValidNetPpw}
                onClick={() => {
                  buildNewProposal();
                }}
              >
                {loading ? (
                  <CircularProgress size={50} color="inherit" />
                ) : (
                  <span>Create New</span>
                )}
              </button>
              {(+proposal.id1 !== +team.id1 ||
                +team.ppw !== +proposal.teamPpw) &&
                signedProp === false &&
                callComplete === false ? (
                <button
                  className={!isValidNetPpw ? "proposalButton disabled" : "proposalButton confirm"}
                  style={{ marginTop: "10px", marginBottom: "0px" }}
                  disabled={loading}
                  onClick={() => {
                    createUpdatedProposal();
                  }}
                >
                  {loading ? (
                    <CircularProgress size={50} color="inherit" />
                  ) : (
                    <span>Sync With Latest Financing</span>
                  )}
                </button>

              ) : null}
              {!isValidNetPpw && (
                <div className="col">
                  <div className="qualyText error">*Net PPW must be greater than or equal to $2.40</div>
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <CallPilot
                variant="welcomeCallOnly"
                financeSource={currentProp.financingSource}
                ppa={loanA?.isPpa}
                envelopeId={envelopeId}
                envelopeStatus={envelopeStatus}
                setEnvelopeStatus={setEnvelopeStatus}
                projectID={customer.projectID}
                loanTerm={loanA?.loanTerm}
                loanApr={loanA?.loanInterest}
                firstMonthPayment={loanA?.firstMonthPayment}
                customerPhone={customer?.phone}
              />
            </div>
          </div>
          <div className="row">
            <SiteSurvey
              projectID={customer.projectID}
              callComplete={callComplete}
              setCallComplete={setCallComplete}
              primaryContact={primaryContact}
              contractSigned={currentProp.contractSigned}
              envelopeStatus={envelopeStatus}
              customerAddress={`${street}, ${city}, ${state} ${zip}`}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProposalMenu;
